<template>
  <v-container class="p5-4 my-5">
    <v-spacer></v-spacer>
    <page-title title="Settings" />
    <v-switch
      inset
      color="var(--purple)"
      label="allow automatic updates"
      v-model="automaticUpdates"
    ></v-switch>
    <v-switch
      inset
      color="var(--purple)"
      label="Save preferences across logged in device"
      v-model="savePreference"
    ></v-switch>
    <v-switch
      inset
      color="var(--purple)"
      label="allow push notification"
      v-model="pushNotification"
    ></v-switch>
    <v-switch inset color="var(--purple)" label="dark mode"> </v-switch>

    <v-switch
      inset
      color="var(--purple)"
      label="subscribe to news letter"
      v-model="newsLetter"
    ></v-switch>
    <v-switch
      inset
      color="var(--purple)"
      label="use beta version"
      v-model="betaVersion"
    ></v-switch>
  </v-container>
</template>

<script>
import PageTitle from "../../components/PageTitle.vue";
export default {
  data: () => ({
    newsLetter: false,
    savePreference: true,
    automaticUpdates: true,
    betaVersion: false,
    pushNotification: false,
  }),
  components: {
    PageTitle,
  },
};
</script>

<style>
</style>